export default "__VITE_ASSET__DD1e$Ztm__"